import { Component } from '@angular/core';

@Component({
  selector: 'app-competency-matrix-widget-demo',
  templateUrl: './competency-matrix-widget-demo.component.html',
  styleUrl: './competency-matrix-widget-demo.component.scss',
  standalone: false
})
export class CompetencyMatrixWidgetDemoComponent {
  data = [
    { categoryId: '1', categoryName: 'Communication', countOfCompletedEventsForUser: 10 },
    { categoryId: '2', categoryName: 'Leadership', countOfCompletedEventsForUser: 6 },
    { categoryId: '3', categoryName: 'Technical', countOfCompletedEventsForUser: 8 },
    { categoryId: '4', categoryName: 'Compliance', countOfCompletedEventsForUser: 4 }
  ];

  readonly maxCategoryLabelLength = 10;
  categoryNames = this.data.map(d => d.categoryName); 
  
  customizeLabel = (info: any): string => {
    const label = info.value;
    return label.length > this.maxCategoryLabelLength
      ? label.slice(0, this.maxCategoryLabelLength) + '…'
      : label;
  };
}
